import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import elementsIds from '@/const/elementIds.json';
import { useOsService } from '@/services/OsService/OsService';
import agentsNavBarListLinux from './agents-table/nav-bar-list/OS/agents-nav-bar-list.linux.vue';
import agentsNavBarListWindows from './agents-table/nav-bar-list/OS/agents-nav-bar-list.windows.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-nav-bar',
  setup(__props) {

const osService = useOsService();

return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isWindows.value)
    ? (_openBlock(), _createBlock(agentsNavBarListWindows, {
        key: 0,
        "data-testid": _unref(elementsIds).agentsNavBar.listWindows
      }, null, 8, ["data-testid"]))
    : (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(agentsNavBarListLinux, {
          key: 1,
          "data-testid": _unref(elementsIds).agentsNavBar.listLinux
        }, null, 8, ["data-testid"]))
      : _createCommentVNode("", true)
}
}

})